<template>
  <div class="rode">
    <div class="exe-section" v-if="type == 1">
      <div class="header-box flex-row">
        <div class="h-title">
          当前知识点：<span class="c_40b8ee title">{{ knowledgeName }}</span>
        </div>
        <div>
          第<span class="c_40b8ee num">{{ index + 1 }}</span
          >题，共<span class="c_40b8ee num">{{ count }}</span
          >题
        </div>
      </div>
      <div class="rode-content">
        <div class="stem" v-html="dataIng.topic"></div>
        <div
          class="stem"
          v-html="dataIng.subtitle"
          v-if="dataIng.subtitle"
        ></div>
        <div class="options-box">
          <el-radio-group v-model="userAnswerIndex">
            <div
              class="options flex-between"
              v-for="(item, index) in dataIng.option"
              :key="index"
            >
              <el-radio :label="index" class="flex-row">{{
                index | optionText
              }}</el-radio>
              <div
                class="item"
                v-html="item"
                @click="onChangeAnswer(index)"
                :class="{ c_40b8ee: userAnswerIndex == index }"
              ></div>
            </div>
          </el-radio-group>
        </div>
      </div>
      <span class="dialog-footer">
        <el-button type="danger" round @click="onRedoClose">退出答题</el-button>
        <el-button type="primary" round @click="onNext">{{
          index + 1 == count ? "确认提交" : "进入下一题"
        }}</el-button>
      </span>
    </div>
    <div class="result-section" v-if="type == 2">
      <div class="result-box">
        <div class="result-header">
          <div class="flex-row r-num-box">
            <span>本次总题数：{{ count }}</span>
            <span>答对：{{ successNum }}</span>
            <span>答错：{{ errorNum }}</span>
            <span>正确率：{{ accuracy }}%</span>
          </div>
          <div class="result-list flex-wrap-start">
            <div
              class="line"
              v-for="(v, i) in answerExerciseList"
              :key="i"
              :class="v.result == 1 ? 'success' : 'error'"
              @click="onLooksExercise(i)"
            >
              {{ i + 1 }}
            </div>
            <div class="r-msg">（点击色块回顾题目）</div>
          </div>
        </div>
        <div class="result-con">
          <div v-if="resultType == 1">是否删除已经做对的试题？</div>
          <div v-if="resultType == 2">
            恭喜你！本知识点下所有错题都做对了！是否全部删除？
          </div>
          <div v-if="resultType == 3">错题未掌握，重新作答或退出？</div>
        </div>
        <div class="dialog-footer">
          <template v-if="resultType != 3">
            <div>
              <el-button type="danger" round @click="onDelete"><div class="button-one">是</div>
              </el-button>
              <el-button type="primary" round
                @click="onClose"><div class="button-one" >否</div></el-button
              >
            </div>
          </template>
           <template v-else>
            <div>
              <el-button type="danger" round
                ><div class="button-one" @click="onAgain">重新作答</div>
              </el-button>
              <el-button type="primary" round
                ><div class="button-one" @click="onClose">退出</div></el-button
              >
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="looks-section" v-if="type == 3">
      <div class="looks-header">
        <span class="l-title">题目作答回顾</span>
      </div>
      <div class="looks-list flex-wrap-center">
        <div
          class="line success"
          v-for="(v, i) in answerExerciseList"
          :key="i"
          @click="onLooksExercise(i)"
          :class="{ texted: i === index, error: v.result == 0 }"
        >
          {{ i + 1 }}
        </div>
      </div>
      <div class="looks-content">
        <div class="stem" v-html="dataIng.topic"></div>
        <div
          class="stem"
          v-html="dataIng.subtitle"
          v-if="dataIng.subtitle"
        ></div>
        <div class="options-box">
          <el-radio-group v-model="dataIng.user_answer_index" disabled>
            <div
              class="options flex-between"
              v-for="(item, index) in dataIng.option"
              :key="index"
              :class="dataIng.user_answer_index == index ? `answer_status_${dataIng.result}` :''"
            >
              <el-radio :label="index" class="flex-row">{{
                index | optionText
              }}</el-radio>
              <div
                class="item"
                v-html="item"
              ></div>
            </div>
          </el-radio-group>
        </div>
        <div class="flex-row-start">
          <span>【答案】</span>
          <div v-html="dataIng.answer"></div>
        </div>
        <div v-html="dataIng.analysis"></div>
      </div>
      <span class="dialog-footer">
        <el-button
          type="primary"
          round
          @click="onLooksLast"
          :disabled="index == 0"
          >上一题</el-button
        >
        <el-button
          type="primary"
          round
          @click="onLooksNext"
          :disabled="answerExerciseList.length - 1 == index"
          >下一题</el-button
        >
        <el-button type="danger" round @click="type = 2">关闭回顾</el-button>
      </span>
    </div>
  </div>
</template>
<script>
import { keepTwoDecimalFull } from "../../config/common";
export default {
  name: "Rode",
  data() {
    return {
      index: 0,
      userAnswerIndex: -1,
      dataIng: {},
      count: 0,
      userExercise: [],
      resultType: 1,
      answerExerciseList: [],
      errorNum: 0,
      successNum: 0,
      accuracy: 0,
      errorCode:'',
      type: 1, //1:答题页面，2：结果页面，3：回顾页面
    };
  },
  props: {
    list: Array,
    knowledgeName: String,
  },
  watch: {
    list() {
      this.init();
    },
  },
  filters: {
    optionText(i) {
      let data = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
      return data[i] + ".";
    },
  },
  created() {
    console.log(this.list);
    this.init();
  },
  methods: {
    init() {
      this.count = this.list.length;
      if (this.count == 0) {
        return false;
      }
      this.index = 0;
      this.type = 1;
      this.errorNum = 0;
      this.successNum = 0;
      this.accuracy = 0;
      this.userAnswerIndex = -1;
      this.resultType = 0;
      this.errorCode = '';
      this.answerExerciseList = [];
      this.dataIng = this.list[this.index];
      this.mathJaxInit();
    },
    onChangeAnswer(index) {
      this.userAnswerIndex = index;
    },
    onNext() {
      if (this.userAnswerIndex === -1) {
        this.$message.warning("请选择答案再下一步");
        return false;
      }
      let auswer = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
      this.userExercise.push({
        user_answer: auswer[this.userAnswerIndex],
        question_id: this.dataIng.question_id,
      });
      let questionIng = this.list[this.index];
      let userAuswerIng = auswer[this.userAnswerIndex];
      let question = Object.assign(questionIng, {
        user_answer_index: this.userAnswerIndex,
        result: questionIng.answer == userAuswerIng ? 1 : 0,
      });
      this.answerExerciseList = [...this.answerExerciseList, question];
      if (this.index < this.count - 1) {
        ++this.index;
        this.userAnswerIndex = -1;
        this.dataIng = this.list[this.index];
        this.mathJaxInit();
        return;
      }
      this.type = 2;
      this.settlement();
    },

    onLooksLast() {
      if (this.index > 0) {
        --this.index;
        this.dataIng = this.answerExerciseList[this.index];
        this.mathJaxInit();
      }
    },

    onLooksNext() {
      if (this.index < this.answerExerciseList.length - 1) {
        ++this.index;
        this.dataIng = this.answerExerciseList[this.index];
        this.mathJaxInit();
      }
    },

    onLooksExercise(index) {
      this.index = index;
      this.dataIng = this.answerExerciseList[this.index];
      this.type = 3;
      this.mathJaxInit();
    },

    onRedoClose() {
      if(this.answerExerciseList.length == 0){
        this.$emit("redoCloseCallBack", false);
        return false;
      }
      this.type = 2;
      this.settlement();
    },

    onClose() { 
      this.$emit("redoCloseCallBack", false);
    },

    onDelete(){
      if(this.errorCode == ''){
        this.$emit("redoCloseCallBack", false);
        return false;
      }
      this.getRequest("/wenjiaoopne/kc/user/question/delUserErrorQuestion",{code: this.errorCode})
        .then((result) => {
          if(result.error_code == 0){
            this.$emit("redoCloseCallBack", false);
            return false;
          }
          this.$message.error(result.message);
        })
        .catch(() => {});
    },

    onAgain(){
      this.init()
    },

    settlement() {
      this.count = this.answerExerciseList.length;
      let errorCodeArr = [];
      console.log(this.answerExerciseList)
      this.answerExerciseList.forEach((v) => {
        this.successNum += v.result;
        if(v.result == 1){
          errorCodeArr.push(v.error_question_code);
        }
      });
      this.errorCode = errorCodeArr.join(',');
      this.errorNum = this.count - this.successNum;
      this.accuracy = keepTwoDecimalFull((this.successNum / this.count) * 100);
      if (this.count == this.errorNum) {
        this.resultType = 3;
      } else if (this.count == this.successNum) {
        this.resultType = 2;
      } else {
        this.resultType = 1;
      }
    },

    mathJaxInit() {
      setTimeout(() => {
        this.$nextTick(function() {
          //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
          if (this.commonsVariable.isMathjaxConfig) {
            //判断是否初始配置，若无则配置。
            this.commonsVariable.initMathjaxConfig();
          }
          this.commonsVariable.MathQueue("question-id"); //传入组件id，让组件被MathJax渲染
        });
      }, 500);
    },
  },
};
</script>
<style scoped>
.rode {
  position: relative;
  width: 100%;
  height: 450px;
  background: url("../../assets/images/error_bg.png");
  background-repeat: no-repeat;
  background-size: 30%;
  background-position: 100% 90%;
}
.result-header {
  border-bottom: 1px dashed #a3afc3;
  padding: 20px 0;
}
.result-header .r-num-box > span {
  margin: 0 20px;
}
.result-header .result-list {
  padding-top: 20px;
}
.result-section {
  width: 600px;
  margin: 0 auto;
}
.result-section .button-one {
  width: 50px;
}
.rode .line {
  width: 30px;
  height: 30px;
  margin: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.result-section .r-msg {
  height: 30px;
  line-height: 30px;
  margin: 5px 0 0 30px;
}
.result-con {
  height: 270px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #000;
}
.looks-list {
  margin: 20px 0;
}
.looks-content {
  height: 300px;
  overflow-y: auto;
}
.looks-section .l-title {
  font-size: 16px;
  font-weight: 700;
  color: #000;
}
.dialog-footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  text-align: center;
}
.rode-content {
  padding-top: 30px;
  height: 330px;
  overflow-y: auto;
}
.rode .stem {
  padding-bottom: 5px;
}
.rode .explain-box {
  width: 100%;
  margin-top: 20px;
}
.rode .explain {
  margin-top: 5px;
}
.rode .options {
  width: 100%;
  position: relative;
  margin: 4px 0;
  cursor: pointer;
}
.rode .item {
  width: 700px;
  display: inline-block;
  padding: 15px 5px;
  line-height: 20px;
}
.rode .exe-section .options:hover {
  /* box-shadow: 0px 1px 10px #f0f0f0; */
  background-color: #fbfbfb;
  border-radius: 10px;
  opacity: 0.8;
}
.rode .footer-box {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.rode .header-box {
  position: relative;
}
.rode .h-title {
  position: absolute;
  left: 0;
}
.rode .h-title .title {
  font-size: 16px;
}
.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.flex-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.flex-row-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.flex-wrap-start {
  display: flex;
  flex-flow: wrap;
  align-content: flex-start;
  align-items: flex-start;
}
.flex-wrap-center {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
}
.texted {
  color: #040300 !important;
}
.num {
  font-size: 26px;
}
.c_40b8ee {
  color: #40b8ee;
}
.success ,.answer_status_1{
  background-color: #6fe7b3;
  color: #fff;
}
.error ,.answer_status_0{
  background-color: #f76570;
  color: #fff;
}
</style>
